export const appHead = {"link":[],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"google-site-verification","content":"googleab2b4543d3fd2cbb.html"},{"name":"google-site-verification","content":"googlebfb9cdd704d501dc.html"},{"name":"google-site-verification","content":"bnb5p6_xk8853zbdF6XE8-DdM9kgjkm9roEJyEsNWGI"},{"property":"og:type","content":"website"}],"style":[],"script":[{"key":"gtag-datalayer-setup","type":"text/javascript","children":"\n                  window.dataLayer = window.dataLayer || [];\n\n                  function gtag() {\n                    dataLayer.push(arguments);\n                  }\n\n                  gtag(\"consent\", \"default\", {\n                    ad_storage: \"denied\",\n                    ad_user_data: \"denied\",\n                    ad_personalization: \"denied\",\n                    analytics_storage: \"denied\",\n                    wait_for_update: 500,\n                  });\n\n                  gtag(\"set\", \"ads_data_redaction\", true);\n\n                  window.uetq = window.uetq || [];\n\n                  window.uetq.push('consent', 'update', {\n                    'ad_storage': 'denied'\n                  });\n                "},{"key":"cookie-information","type":"text/javascript","id":"CookieConsent","src":"https://policy.app.cookieinformation.com/uc.js","data-culture":"PT","data-gcm-version":"2.0","tagPriority":"after:script:gtag-datalayer-setup"},{"type":"text/javascript","children":"\n          var cggCiabVersion = \"ciab_3.75\";\n        ","tagPriority":"after:script:cookie-information"}],"noscript":[],"viewport":"width=device-width, initial-scale=1","htmlAttrs":{}}

export const appPageTransition = {"name":"layout","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true